/**
 * SF-4652: the review map's pins. Eva gives each demo location item its Google place's map point
 * (`location`, sf-chat-service demo-builder.view.ts); one without a real point is only listed.
 */
import type { ChangeSetItem } from './api/demoBuildsClient';
import type { MapPin } from './components/AreaMap';

const isCoordinate = (v: unknown, max: number): v is number =>
  typeof v === 'number' && Number.isFinite(v) && Math.abs(v) <= max;

/** The location's name from its summary ("Location: Leeds (1 High St, LS1 1AA)"), else the summary. */
export const locationName = (summary: string) =>
  /^Location: (.+?)(?: \([^()]*\))?$/.exec(summary)?.[1] ?? summary;

/** A pin for each location that has a real map point; one with none is only listed. */
export const pinsOf = (items: ChangeSetItem[]): MapPin[] =>
  items
    .filter((i) => isCoordinate(i.location?.lat, 90) && isCoordinate(i.location?.lng, 180))
    .map((i) => ({
      key: i.ref,
      position: { lat: i.location!.lat, lng: i.location!.lng },
      title: locationName(i.summary),
    }));
